var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 65,
    viewBox: "0 0 60 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1858_6861)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 62.3164,
    width: 55.2,
    height: 60,
    rx: 3,
    transform: "rotate(-180 58 62.3164)",
    fill: "#188C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2 25.915C41.2 31.4379 36.7228 35.915 31.2 35.915L29.6 35.915C24.0771 35.915 19.6 31.4379 19.6 25.915L19.6 14.315L41.2 14.315L41.2 25.915Z",
    fill: "#1B2B41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.8,
    y: 14.3164,
    width: 40.8,
    height: 12,
    transform: "rotate(-180 50.8 14.3164)",
    fill: "#1B2B41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 26.3174,
    width: 4.8,
    height: 12,
    transform: "rotate(90 58 26.3174)",
    fill: "#1B2B41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8,
    y: 26.3174,
    width: 4.8,
    height: 12,
    transform: "rotate(90 14.8 26.3174)",
    fill: "#1B2B41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1858_6861",
    x: 0.800049,
    y: 0.316406,
    width: 59.2,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1858_6861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1858_6861",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder);
export default __webpack_public_path__ + "static/media/user-placeholder.babf3c11205a6b0eeff6886045e9f392.svg";
export { ForwardRef as ReactComponent };